<template>
  <div>
    <head-nav-bar :title="title" :fixed="true" />
    <div class="mt-header-nav room-form">
      <van-cell-group>
        <van-cell class="custom-filed">
          <van-row>
            <van-col span="12">
              <van-field
                class="my-name"
                v-model="form.contact"
                required
                clearable
                label="姓名"
                placeholder="请输入姓名"
                @input="changeName"
                @focus="focusName"
                @blur="show = false"
              />
            </van-col>
            <van-col span="12">
              <van-field
                class="phone"
                v-model="form.phone"
                type="tel"
                clearable
                label="电话"
                placeholder="请输入电话"
              />
            </van-col>
          </van-row>
        </van-cell>
        <form-select
          label="渠道"
          :required="defaultItem.MustFillChannel == '1'"
          v-model="form.chanel"
          :columns="ChannelData"
          @change="handleChanel"
        ></form-select>
        <!-- <form-select
          label="业务员"
          v-model="form.salesmanId"
          :columns="salesmanData"
        ></form-select> -->
        <van-field
          label="客户"
          placeholder="请选择客户"
          @click="handleCustomer"
          v-model="form.customerName"
          right-icon="arrow"
          disabled
        />
        <van-field
          label="会员卡"
          placeholder="请选择会员卡"
          @click="handleMember"
          v-model="form.member.Name"
          right-icon="arrow"
          disabled
        />
        <form-select
          label="价类"
          :required="true"
          v-model="form.priceCode"
          :columns="pricecodeData"
          @change="data => handlePriceCode(data.Id)"
        ></form-select>
        <form-select
          label="付款方式"
          v-model="form.payway"
          :columns="paywayData"
          :readonly="isUpdate"
          @change="handlePayWay"
        ></form-select>
        <van-cell :class="{ 'custom-filed': true, 'readonly-cls': isUpdate }">
          <van-row>
            <van-col span="12">
              <van-field
                :readonly="isUpdate"
                :disabled="isUpdate"
                class="money"
                type="number"
                v-model="form.money"
                label="金额"
                placeholder="请输入金额"
              />
            </van-col>
            <van-col span="12">
              <van-field
                v-model="form.billNo"
                clearable
                label="单据号"
                :readonly="isUpdate"
                :disabled="isUpdate"
                placeholder="请输入单据号"
              />
            </van-col>
          </van-row>
        </van-cell>
        <van-field
          label="备注信息"
          placeholder="请输入备注信息"
          v-model="form.remark"
          rows="2"
          autosize
          type="textarea"
        />
      </van-cell-group>

      <van-row>
        <van-col span="24">
          <roomInfo
            ref="roomInfo"
            :option="roomInfoOption"
            :defaultItem="defaultItem"
            :isHourRoom="IsHourRoom"
            :hourNumber="HourNumber"
            :CompanyId="CompanyId"
            @update="updateName"
            @change="changeDailyPrice"
            @calculate="calculateRoomPrice"
          ></roomInfo>
        </van-col>
      </van-row>
      <van-goods-action>
        <div class="total" slot="default">
          <small>合计：</small>{{ totalMoney }}
        </div>
        <van-goods-action-button
          type="info"
          v-if="roomInfo.actionType == 'order'"
          text="预定"
          @click="onSubmit"
        />
        <van-goods-action-button
          type="info"
          v-if="isUpdate"
          text="修改订单"
          @click="onSubmit"
        />
      </van-goods-action>
    </div>
    <van-popup
      v-model="visible.showResult"
      close-icon-position="top-left"
      position="top"
      closeable
      @close="onClose"
      :style="{ height: '100%' }"
    >
      <result state="success">
        <div slot="title">{{ title }}成功</div>
        <div slot="desc">
          <div style="width:50%;margin:0 auto">
            {{ desc }}
          </div>
          <div class="to-detail" v-if="!fail">
            <van-cell title="查看订单" is-link value="详情" :to="toDetail" />
          </div>
        </div>
      </result>
    </van-popup>
    <van-popup
      class="name-pop"
      v-model="show"
      :style="{ height: '30%' }"
      :overlay="false"
    >
      <ul>
        <li
          v-for="(item, index) in nameDataSource"
          @click="selectName(item)"
          :key="index"
        >
          {{ item.Contact }}
          <span style="float:right">{{ item.Phone }}</span>
        </li>
      </ul>
    </van-popup>
  </div>
</template>

<script>
import {
  Cell,
  CellGroup,
  Row,
  Col,
  Field,
  Toast,
  NumberKeyboard,
  Button,
  GoodsAction,
  GoodsActionIcon,
  GoodsActionButton,
  Popup,
  Icon,
  Dialog,
  Notify,
} from "vant";
import { ls } from "@/utils/cache.js";
import { getGSelectData } from "@/api/common.js";
import groupOrderApi from "../../api/group_order.js";
import { getUserList } from "@/api/user.js";
import { mapState } from "vuex";
import groupRoomApi from "../../api/group_room.js";
import roomInfo from "./roomComponent/RoomInfo.vue";
import formSelect from "@/components/form-select";
import cloneDeep from "lodash/cloneDeep";
import Result from "@/components/result";
import selectMember from "@/components/select-member/function.js";
import MemberPasswordVerify from "@/components/member-password-verify/function.js";
import { checkPhone } from "@/utils/common.js";
import { ROOMINFO } from "@/store/mutation-types";
import moment from "moment";
export default {
  name: "roomLog",
  components: {
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [Row.name]: Row,
    [Col.name]: Col,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [NumberKeyboard.name]: NumberKeyboard,
    [Button.name]: Button,
    [GoodsAction.name]: GoodsAction,
    [GoodsActionIcon.name]: GoodsActionIcon,
    [GoodsActionButton.name]: GoodsActionButton,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    roomInfo,
    formSelect,
    Result,
  },
  data() {
    return {
      title: "预定",
      submitMethod: "",
      form: {
        contact: "",
        phone: "",
        chanel: "",
        salesmanId: "",
        customerId: "",
        customerName: "",
        member: {},
        memberPass: "",
        priceCode: "",
        payway: "",
        money: "",
        billNo: "",
        remark: "",
      },
      params: {},
      visible: {
        showKeyboard: false,
        showResult: false,
        // showMemberPass: false
      },
      defaultItem: {},
      priceStructureData: [],
      pickerData: [],
      ChannelData: [],
      customerData: [],
      salesmanData: [],
      memberData: [],
      pricecodeData: [],
      paywayData: [],
      roomInfoOption: {},
      roomGridData: [],
      desc: "",
      toDetail: "",
      orderId: "",
      orderNo: "",
      fail: false,
      totalMoney: 0,
      isUpdate: false,
      isAllCancel: false,
      IsHourRoom: false,
      HourNumber: "",
      CompanyId: "",
      show: false,
      nameDataSource: [],
    };
  },
  watch: {
    roomInfoOption: {
      handler: function() {
        this.calculateTotalPrice();
      },
      deep: true,
    },
  },
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  created() {
    this.roomInfo = ls.get(ROOMINFO);
    this.CompanyId = this.roomInfo.CompanyId;
    this.roomInfoOption = cloneDeep(this.roomInfo);
    const type = this.roomInfoOption.actionType;
    this.getDefaultItem();
    this.getFormSelectData();
    if (type == "order") {
      this.submitMethod = "GroupCreateOrder";
      this.title = "预定";
    } else if (type == "update") {
      this.submitMethod = "GroupUpdateOrder";
      this.title = "修改订单";
      this.isUpdate = true;
      this.orderId = this.$route.query.id;
      this.handleUpdateData();
    }
  },
  methods: {
    changeName(value) {
      this.nameDataSource = [];
      if (value && value.length > 1) {
        groupRoomApi
          .GetContact({
            CompanyId: this.CompanyId,
            Contact: value && value.trim(),
            PageIndex: 0,
            PageSize: 10000,
          })
          .then(res => {
            this.nameDataSource = res.Data.Datas;
            if (res.Data.Datas.length) {
              this.show = true;
            } else {
              this.show = false;
            }
          })
          .catch(() => {
            this.show = false;
          });
      } else {
        this.show = false;
      }
    },
    selectName(item) {
      this.show = false;
      this.form.contact = item.Contact;
      this.form.phone = item.Phone;
    },
    focusName() {
      if (this.form.contact.length > 1) {
        this.changeName(this.form.contact);
      }
    },
    onSubmit() {
      if (!this.validate()) {
        return;
      }
      const form = this.form;
      const formData = {
        Contact: this.convertValue(form.contact),
        Phone: this.convertValue(form.phone),
        ContactRemark: this.convertValue(form.remark),
        AccountItemId: this.convertValue(form.payway),
        BillNo: this.convertValue(form.billNo),
        Deposit: this.convertValue(form.money),
        SalesmanId: this.convertValue(form.salesmanId),
        ChannelId: this.convertValue(form.chanel),
        CustomerId: this.convertValue(form.customerId),
        MemberCardNo: this.convertValue(form.member.CardNo),
        MemberCardId: this.convertValue(form.member.Id),
        MemberName: this.convertValue(form.member.Name),
        PriceCodeId: this.convertValue(form.priceCode),
        IsHourRoom: this.IsHourRoom,
      };
      const details = this.roomInfoOption.gridData.map(v => {
        let inTime = v.inTime ? v.inTime : this.defaultItem.ArrivalsTime;
        let outTime = v.outTime ? v.outTime : this.defaultItem.DepartureTime;
        if (
          this.form.member &&
          this.form.member.Id &&
          this.form.member.Id != 0
        ) {
          outTime = this.form.member.CheckoutTime
            ? this.form.member.CheckoutTime
            : this.defaultItem.DepartureTime;
        }
        if (this.IsHourRoom) {
          inTime = "";
          outTime = "";
        }
        const info = {
          Id: v.Id,
          OrderId: v.isNew ? 0 : this.orderId,
          OrderStatus: v.OrderStatus,
          StatusName: v.StatusName,
          CheckInTime: v.daterange[0] + " " + inTime,
          CheckOutTime: v.daterange[1] + " " + outTime,
          RoomTypeId: v.roomTypeId,
          RoomTypeName: v.roomTypeName,
          RoomId: this.convertValue(v.roomId),
          RoomNo: this.convertValue(v.roomNo),
          PriceStructureId: this.convertValue(v.priceStructure),
          TransactionPrices: cloneDeep(v.TransactionPrices),
          Persons: v.Persons,
        };
        info.RoomPrice = info.TransactionPrices[0].Price;
        info.TransactionPrices.forEach(el => {
          el.RoomNo = info.RoomNo;
        });
        return info;
      });
      this.params = {
        ...formData,
        Details: details,
        CompanyId: this.CompanyId,
      };
      const payId = this.isMemberPayMethod();
      if (payId && form.payway == payId && !this.form.member.CardNo) {
        Notify("付款方式为会员卡消费，请选择会员卡！");
        return;
      }
      if (payId && form.member.CardNo && form.payway == payId) {
        if (
          this.isUpdate &&
          this.form.member.Id == this.roomInfo.MemberCardId
        ) {
          //
        } else {
          if (Number(this.form.member.Balance) < Number(this.form.money)) {
            Notify("会员卡余额不足！");
            return;
          }
          MemberPasswordVerify({
            showMoney: !this.isUpdate,
            title: "请输入会员卡密码",
            MemberCardId: form.member.Id,
            money: form.money ? form.money : 0,
            success: password => {
              console.log("success", password);
              this.handleSubmit();
            },
            // error: () => {
            //   console.log("error");
            // },
          });
          return;
        }
      }
      this.handleSubmit();
    },
    handleSubmit() {
      if (this.isUpdate) {
        this.params = {
          ...this.params,
          Id: this.orderId,
          OrderNo: this.orderNo,
        };
      }
      if (this.isAllCancel) {
        this.toDetail =
          "../groupOrder/detail?id=" +
          this.orderId +
          "&companyId=" +
          this.CompanyId;
        this.visible.showResult = true;
      } else {
        groupOrderApi[this.submitMethod](this.params).then(res => {
          this.fail = false;
          this.desc = "已" + this.title + "成功，请及时联系客人确认入住信息";
          if (this.roomInfoOption.actionType != "update") {
            this.orderId = res.Data;
          }
          this.toDetail =
            "../groupOrder/detail?id=" +
            this.orderId +
            "&companyId=" +
            this.CompanyId;
          this.visible.showResult = true;
        });
      }
    },
    validate() {
      if (!this.form.contact) {
        Notify("姓名不能为空！");
        return false;
      }
      const validPhone = checkPhone(this.form.phone);
      if (this.form.phone && !validPhone) {
        Notify("手机号码格式不对！");
        return false;
      }
      if (Number(this.form.money) > 0 && !this.form.payway) {
        Notify("金额大于0，请选择付款方式");
        return false;
      }
      if (!this.form.priceCode || this.form.priceCode == 0) {
        Notify("请选择价类！");
        return false;
      }
      if (
        this.defaultItem.MustFillChannel == "1" &&
        (!this.form.chanel || this.form.chanel == 0)
      ) {
        Notify("请选择渠道！");
        return false;
      }
      if (!this.roomInfoOption.gridData.length) {
        Notify("请添加房间信息！");
        return false;
      }
      const formIsValid = this.roomInfoOption.gridData.every(
        field => field.roomTypeId !== "",
      );
      if (!formIsValid) {
        Notify("请选择房型！");
        return false;
      }
      const dateValid = this.roomInfoOption.gridData.every(
        field =>
          field.daterange &&
          field.daterange[0] !== "" &&
          field.daterange[1] !== "",
      );
      if (!dateValid) {
        Notify("请选择日期！");
        return false;
      }
      return true;
    },
    convertValue(val) {
      return !val || val.trim() == "" || val.trim() == "0"
        ? undefined
        : val.trim();
    },
    /**处理修改订单数据 */
    handleUpdateData() {
      // const
      const updateData = cloneDeep(this.roomInfo);
      this.orderNo = updateData.OrderNo;
      this.IsHourRoom = updateData.IsHourRoom;
      if (this.IsHourRoom) {
        this.HourNumber = moment(updateData.Details[0].CheckOutTime).diff(
          moment(updateData.Details[0].CheckInTime),
          "hours",
        );
      }
      this.form = {
        contact: updateData.Contact,
        phone: updateData.Phone,
        chanel: updateData.ChannelId,
        salesmanId: updateData.SalesmanId,
        customerId: updateData.CustomerId,
        customerName: updateData.CustomerName,
        member: {
          Name: updateData.MemberName,
          CardNo: updateData.MemberCardNo,
          Id: updateData.MemberCardId,
        },
        priceCode: updateData.PriceCodeId,
        payway: updateData.AccountItemId,
        money: String(updateData.Deposit),
        billNo: updateData.BillNo,
        remark: updateData.ContactRemark,
      };
      const gridData = [];
      updateData.Details.forEach(v => {
        const params = {
          CheckInTime: v.CheckInTime,
          CheckOutTime: v.CheckOutTime,
          RoomTypeId: v.RoomTypeId,
          CompanyIds: [this.CompanyId],
          OrderId: this.orderId,
        };
        groupRoomApi.GetRoomAvailable(params).then(res => {
          const json = {
            Id: v.Id,
            OrderId: this.orderId,
            daterange: this.IsHourRoom
              ? [
                  moment(v.CheckInTime).format("YYYY-MM-DD HH:mm"),
                  moment(v.CheckOutTime).format("YYYY-MM-DD HH:mm"),
                ]
              : [
                  moment(v.CheckInTime).format("YYYY-MM-DD"),
                  moment(v.CheckOutTime).format("YYYY-MM-DD"),
                ],
            days: moment(v.CheckOutDate).diff(moment(v.CheckInDate), "d"),
            inTime: moment(v.CheckInTime).format("HH:mm"),
            outTime: moment(v.CheckOutTime).format("HH:mm"),
            price: v.DailyPrices[0].Price,
            roomTypeId: v.RoomTypeId,
            roomTypeName: v.RoomTypeName,
            roomId: v.RoomId,
            roomNo: v.RoomNo,
            roomNoList: res.Data.RoomNos,
            Persons: v.Persons,
            priceStructure: v.PriceStructureId,
            OrderStatus: v.OrderStatus,
            StatusName: v.StatusName,
            disabled: {
              disabledStart:
                v.OrderStatus == 2 ||
                v.OrderStatus == 4 ||
                v.OrderStatus == 1 ||
                this.IsHourRoom,
              disabledEnd: v.OrderStatus == 2 || this.IsHourRoom,
            },
          };
          json.baseDaterange = [
            moment(v.CheckInTime).format("YYYY-MM-DD"),
            moment(v.CheckOutTime).format("YYYY-MM-DD"),
          ];
          if (v.OrderStatus == 4 || v.OrderStatus == 2 || v.OrderStatus == 3) {
            //完成或者取消或者暂离
            json.isDisabled = true;
          }
          if (v.OrderStatus == 1) {
            //在住
            json.isInRoom = true;
          }
          json.TransactionPrices = v.DailyPrices.map(el => {
            return {
              Id: el.Id,
              PriceDate: el.PriceDate,
              Price: el.Price,
              RoomNo: v.RoomNo,
            };
          });
          json.BaseTransactionPrices = cloneDeep(json.TransactionPrices);
          json.DailyPrices = cloneDeep(json.TransactionPrices);
          gridData.push(json);
        });
      });
      const data = {
        gridData: gridData,
        orderId: this.orderId,
        actionType: updateData.actionType,
        jumpToName: updateData.jumpToName,
      };
      this.roomInfoOption = data;
    },
    onClose() {
      if (this.isUpdate) {
        this.$router.push({
          name: this.roomInfoOption.jumpToName,
          query: { id: this.orderId, companyId: this.companyId },
        });
      } else {
        this.$router.push({ name: this.roomInfoOption.jumpToName });
      }
    },
    //获取系统参数值
    getDefaultItem() {
      groupOrderApi.GetGroupDefault({ CompanyId: this.CompanyId }).then(res => {
        this.defaultItem = {
          PriceCodeId: res.Data.PriceCodeId,
          IsIndependentPriceCode: res.Data.IsIndependentPriceCode,
          IsHoldTotalPrice: res.Data.IsHoldTotalPrice,
        };
        res.Data.TimeList.forEach(item => {
          this.defaultItem[item.Code] = item.Value;
        });

        if (this.roomInfoOption.actionType == "order") {
          const _this = this;
          this.roomInfoOption.gridData.forEach((el, index) => {
            el.inTime = this.defaultItem.ArrivalsTime;
            el.outTime = this.defaultItem.DepartureTime;
            _this.$nextTick(() => {
              _this.$refs.roomInfo.getRoomNos(el, index, 1);
            });
          });
        }
        if (!this.form.priceCode || this.form.priceCode == 0) {
          this.handlePriceCode(res.Data.PriceCodeId);
        }
      });
    },
    /**选择价类*/
    handlePriceCode(Id) {
      this.form.priceCode = Id;
      const result = this.pricecodeData.find(
        item => item.Id == Id && item.BackUpBool,
      );
      this.IsHourRoom = result != undefined;
      this.HourNumber = result != undefined ? Number(result.BackUpInt) : 0;
      if (this.roomInfoOption.gridData && this.roomInfoOption.gridData.length) {
        this.roomInfoOption.gridData.forEach((item, index) => {
          if (this.IsHourRoom) {
            const date = moment().format("YYYY-MM-DD");
            if (item.OrderStatus != 4 && item.OrderStatus != 2) {
              if (this.roomInfoOption.actionType !== "update") {
                item.inTime = moment().format("HH:mm");
              }
              item.outTime = moment(date + " " + item.inTime)
                .add(this.HourNumber, "h")
                .format("HH:mm");
              item.daterange = [
                date + " " + item.inTime,
                date + " " + item.outTime,
              ];
              item.disabled = {
                disabledStart: true,
                disabledEnd: true,
              };
            }
          } else {
            item.daterange = item.baseDaterange;
            item.disabled =
              this.roomInfoOption.actionType == "update"
                ? {
                    disabledStart:
                      item.OrderStatus == 2 ||
                      item.OrderStatus == 4 ||
                      item.OrderStatus == 1,
                    disabledEnd: item.OrderStatus == 2,
                  }
                : {
                    disabledStart: this.roomInfoOption.actionType == "checkin",
                    disabledEnd: false,
                  };
          }
          if (item.OrderStatus != 2) {
            this.changeDailyPrice(item, index);
          }
        });
      }
    },
    /**选择渠道*/
    handleChanel(data) {
      if (
        !this.defaultItem.IsIndependentPriceCode &&
        !Number(this.form.customerId) &&
        data.Data
      ) {
        this.handlePriceCode(data.Data.PriceCodeId);
      }
    },
    clearPriceCode() {
      const result = this.pricecodeData.find(
        el => el.Id == this.form.priceCode && !el.disabled,
      );
      if (!result) {
        this.form.priceCode = "";
      }
    },
    // filterPriceCode(filterName, PriceCodeId) {
    //   const result = this.pricecodeData.find(
    //     el => el.Id == PriceCodeId && !el.disabled
    //   );
    //   this.form.priceCode = result ? PriceCodeId : "";
    // },
    setPriceCode() {
      const today = moment().format("YYYY-MM-DD");
      let endDay = today;
      this.pricecodeData = this.pricecodeData.map(item => {
        let isBetween = true;
        if (item.Data && (!item.Data.OffStartTime || !item.Data.OffEndTime)) {
          //如果可用时间段没选或者只选开始或结束 则不判断可用时间段
          isBetween = true;
        } else {
          const start = item.Data.OffStartTime;
          const end = item.Data.OffEndTime;
          //跨天
          if (moment(today + " " + end).isSameOrBefore(today + " " + start)) {
            endDay = moment()
              .add(1, "d")
              .format("YYYY-MM-DD");
          }
          isBetween = moment(moment().format("YYYY-MM-DD HH:mm")).isBetween(
            today + " " + start,
            endDay + " " + end,
          );
        }
        //会员专用或者客户专用或者在不在可用时间段内，价类初始不可选
        if (
          (item.Data.IsCustomerUse &&
            (!this.form.customerId || this.form.customerId == "0")) ||
          (item.Data.IsMemberUse &&
            (!this.form.member.Id || this.form.member.Id == 0)) ||
          !isBetween
        ) {
          item.disabled = true;
        } else {
          item.disabled = false;
        }
        return item;
      });
    },
    /**选择客户*/
    handleCustomer() {
      selectMember({
        method: getUserList,
        placeholder: "请输入客户姓名/编号",
        labelField: "Code",
        searchField: "Name",
        height: "80%",
        change: info => {
          this.form.customerId = info.Id;
          this.form.customerName = info.Name;
          this.setPriceCode();
          if (
            !this.defaultItem.IsIndependentPriceCode &&
            !this.form.member.CardNo &&
            info.PriceCodeId &&
            info.PriceCodeId != "0"
          ) {
            this.form.priceCode = info.PriceCodeId;
            this.handlePriceCode(info.PriceCodeId);
          }
        },
        clear: () => {
          this.form.customerId = "";
          this.form.customerName = "";
          this.setPriceCode();
          this.clearPriceCode();
        },
      });
    },
    /**选择会员卡*/
    handleMember() {
      //显示会员卡选择器
      // if (this.isUpdate) {
      //   return;
      // }
      selectMember({
        height: "80%",
        change: info => {
          this.form.member = info;
          const payId = this.isMemberPayMethod();
          if (payId && this.roomInfoOption.actionType != "update") {
            this.form.payway = payId;
          }
          if (!this.form.contact) {
            this.form.contact = info.Name;
          }
          this.setPriceCode();
          if (
            !this.defaultItem.IsIndependentPriceCode &&
            info.PriceCodeId &&
            info.PriceCodeId !== "0"
          ) {
            this.form.priceCode = info.PriceCodeId;
            this.handlePriceCode(info.PriceCodeId);
          }
        },
        clear: () => {
          this.form.member = {
            CardNo: "",
            Name: "",
            Id: "",
          };
          this.setPriceCode();
          this.clearPriceCode();
          if (!this.defaultItem.IsIndependentPriceCode) {
            if (
              this.form.customerId &&
              this.currentCustomer.PriceCodeId &&
              this.currentCustomer.PriceCodeId != "0"
            ) {
              this.form.priceCode = this.currentCustomer.PriceCodeId;
              this.handlePriceCode(this.currentCustomer.PriceCodeId);
            }
          }
        },
      });
    },
    /**是否选择会员卡，并返回会员卡ID*/
    isMemberPayMethod() {
      const accountItem = this.paywayData.find(
        item => (item.Attributes & 4096) > 0,
      );
      if (accountItem) {
        return accountItem.Id;
      }
      return "";
    },
    /**选择付款方式*/
    handlePayWay(/*data*/) {},
    setDailyPrice(record) {
      const start = record.daterange[0];
      const end = record.daterange[1];
      const dNum = moment(end, "YYYY-MM-DD").diff(
        moment(start).format("YYYY-MM-DD"),
        "d",
      );
      const days = dNum ? dNum : 1;
      record.TransactionPrices = [];
      for (let i = 0; i < days; i++) {
        record.TransactionPrices.push({
          Date: moment(start, "YYYY-MM-DD")
            .add(i, "d")
            .format("YYYY-MM-DD"),
          Price: record.BaseTransactionPrices[i]
            ? record.BaseTransactionPrices[i].Price
            : record.price,
          RoomTypeId: record.roomTypeId,
          RoomTypeName: record.roomTypeName,
        });
      }
      record.BaseTransactionPrices = record.TransactionPrices.map(v => {
        v.PriceDate = v.Date;
        return v;
      });
      // if (this.defaultItem.RoomPriceInputModel == "1") {
      //   //总房价
      //   this.$refs.roomInfo.handleTotalRoomPrice(record);
      // }
      // this.calculateTotalPrice();
    },
    /**计算每日价格*/
    changeDailyPrice(record, index) {
      this.roomInfoOption.gridData[index].roomNoList = record.roomNoList;
      const _this = this;
      let start = "",
        end = "";
      if (record.daterange) {
        start = record.daterange[0];
        end = record.daterange[1];
      } else {
        return false;
      }
      if (this.form.priceCode == "") {
        return false;
      }
      const isBeforeToday = moment(start, "YYYY-MM-DD").isBefore(
        this.user.AccountDate,
      );
      let checkInDate = moment(start).format("YYYY-MM-DD");
      if (
        this.IsHourRoom &&
        this.user.AccountDate != moment().format("YYYY-MM-DD") &&
        !isBeforeToday &&
        this.roomInfo.OrderAttr != "2"
      ) {
        checkInDate = this.user.AccountDate;
      }
      const params = {
        CompanyId: this.CompanyId,
        CheckInDate: checkInDate,
        CheckOutDate: moment(end).format("YYYY-MM-DD"),
        RoomTypeId: record.roomTypeId,
        PriceCodeId: this.form.priceCode,
      };
      groupOrderApi.GroupRoomPrice(params).then(res => {
        let result = _this.priceStructureData.find(
          price => price.Id == record.priceStructure,
        );
        const addPrice = result && result.Data ? result.Data.Price : 0;
        let opt = cloneDeep(_this.roomInfoOption.gridData);
        record.price = res.Data[0].Price;
        opt[index].price = res.Data[0].Price;
        let data = cloneDeep(res.Data);

        if (data.length) {
          const price = data.length ? data[0].Price : 0;
          opt[index].TransactionPrices = data.map((v, index) => {
            if (Number(addPrice) > 0) {
              v.Price = (Number(v.Price) + Number(addPrice)).toFixed(2);
            }
            v.PriceDate = v.Date;
            v.RoomNo = record.roomNo;
            if (this.roomInfoOption.actionType == "update") {
              v.Price =
                record.DailyPrices && record.DailyPrices[index]
                  ? record.DailyPrices[index].Price
                  : v.Price;
            }
            return v;
          });
          opt[index].price = price;
          opt[index].BaseTransactionPrices = res.Data.map(v => {
            v.PriceDate = v.Date;
            return v;
          });
        }
        _this.roomInfoOption = {
          ..._this.roomInfoOption,
          gridData: opt,
        };
        _this.calculateTotalPrice();
      });
    },
    calculateRoomPrice(isAllCancel) {
      this.isAllCancel = isAllCancel;
      this.calculateTotalPrice();
    },
    //计算总价
    calculateTotalPrice() {
      let total = 0;
      if (this.roomInfoOption.gridData && this.roomInfoOption.gridData.length) {
        this.roomInfoOption.gridData.forEach(item => {
          if (
            item.OrderStatus != 4 &&
            item.OrderStatus != 2 &&
            item.TransactionPrices &&
            item.TransactionPrices.length
          ) {
            item.TransactionPrices.forEach(el => {
              total += Number(el.Price);
            });
          }
        });
        this.totalMoney = total.toFixed(2);
      } else {
        this.totalMoney = "0.00";
      }
    },
    updateName(name) {
      if (!this.form.contact) {
        this.form.contact = name;
      }
    },
    /**获取搜索数据，包括房型数据和房间状态数据 */
    getFormSelectData() {
      const _this = this;
      //获取渠道列表
      getGSelectData({
        Types: "companychannel",
        CompanyId: _this.CompanyId,
      }).then(res => {
        _this.ChannelData = res.Data.companychannel;
      });
      //获取客户列表
      getGSelectData({
        Types: "customer",
        CompanyId: _this.CompanyId,
      }).then(res => {
        _this.customerData = res.Data.customer;
      });
      //获取业务员列表
      getGSelectData({
        Types: "Salesman",
        CompanyId: _this.CompanyId,
      }).then(res => {
        _this.salesmanData = res.Data.Salesman;
      });
      //获取价类
      getGSelectData({
        Types: "pricecode",
        CompanyId: _this.CompanyId,
      }).then(res => {
        _this.pricecodeData = res.Data.pricecode;
        _this.setPriceCode();
      });
      //获取价构列表
      getGSelectData({
        Types: "PriceStructure",
        CompanyId: this.CompanyId,
      }).then(res => {
        this.priceStructureData = res.Data.PriceStructure;
      });
      //获取付款方式
      getGSelectData({
        Types: "payway",
        CompanyId: _this.CompanyId,
      }).then(res => {
        this.paywayData = res.Data.payway.map(item => {
          if (item.Data && item.Data.Attributes && item.Data.Attributes === 2) {
            item.disabled = true;
          }
          return item;
        });
      });
    },
  },
};
</script>
<style lang="less">
.van-cell {
  .van-field__label {
    width: 1.9rem;
  }
}
.custom-filed {
  padding: 0;
}
.room-form {
  // padding-bottom: 1.16667rem;
  .total {
    color: #f00;
    font-size: 18px;
    line-height: 1.06667rem;
    padding: 0 10px;
  }
  /deep/.van-field__control:disabled {
    color: #323233;
    -webkit-text-fill-color: #323233;
    &::-webkit-input-placeholder {
      -webkit-text-fill-color: #999 !important;
    }
  }
}
.to-detail {
  text-align: left;
  border-top: 1px solid #f6f6f6;
  border-bottom: 1px solid #f6f6f6;
  margin-top: 20px;
  /deep/.van-cell__value {
    color: #000;
    font-size: 16px;
  }
}
.readonly-cls {
  background: #f9f9f9 !important;
  /deep/.van-field__right-icon {
    display: none;
  }
  .van-cell {
    background: #f9f9f9 !important;
  }
}
.van-cell .phone .van-field__label {
  width: 1rem;
}
.name-pop {
  top: 185px;
  left: 50%;
  width: 64%;
  border-radius: 3px;
  background: #ecf4ff;
  padding: #e9f6ff;
  li {
    border-bottom: 1px dashed #d5d5d5;
    padding: 8px 10px;
    font-size: 12px;
    color: 666;
    &:focus,
    &:active {
      background: #c4e7ff;
    }
  }
}
</style>
